import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space, WizardProgress } from '@redlink/components/atoms';

export const SetupPageTitle = memo(
  ({ title, subtitle, description, hints, step }) => {
    const { styles } = useStyle();
    return (
      <View style={styles.container}>
        <Text style={styles.title}>{title}</Text>
        <Space size={32} />
        <Text style={styles.subtitle}>{subtitle}</Text>
        <Space />
        <WizardProgress current={step} length={5} />
        <Space size={8} />
        <Text style={styles.description}>{description}</Text>
        {hints && <Text style={styles.hints}>{hints}</Text>}
      </View>
    );
  }
);

const useStyle = createUseStyle(({ colors, shadow, size }) => ({
  container: {},
  title: {
    fontSize: 15,
    color: colors.black4,
  },
  subtitle: {
    fontSize: 16,
    color: colors.black,
    fontWeight: 'bold',
  },
  description: {
    fontSize: 14,
    color: colors.black4,
  },
  hints: {
    fontSize: 12,
    color: colors.black4,
  },
}));
